var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartControlPanRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "gray",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Interactive-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-3",
    fill: "#B7B7B7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M7.29289322,4.29289322 C6.90236893,4.68341751 6.90236893,5.31658249 7.29289322,5.70710678 L11.5857864,10 L7.29289322,14.2928932 C6.90236893,14.6834175 6.90236893,15.3165825 7.29289322,15.7071068 C7.68341751,16.0976311 8.31658249,16.0976311 8.70710678,15.7071068 L13.7071068,10.7071068 C14.0976311,10.3165825 14.0976311,9.68341751 13.7071068,9.29289322 L8.70710678,4.29289322 C8.31658249,3.90236893 7.68341751,3.90236893 7.29289322,4.29289322 Z",
    id: "Icon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartControlPanRight);
export default __webpack_public_path__ + "static/media/chartControl_PanRight.07c1cf3a7a35432348d8f0e21730ceab.svg";
export { ForwardRef as ReactComponent };